module Meevo.Plugins.AlertsManager {

    import NotificationMethodEnum = Meevo.Model.NotificationMethodEnum;

    class MeevoNotifyViaTabComponent implements ng.IComponentController {

        public params: IParams;

        constructor() {
            Object.defineProperty(this.params, 'notificationMethod', {
                get() {
                    let arr: Array<NotificationMethodEnum> = [];

                    if (this.notifyVia.sms) arr.push(NotificationMethodEnum.Sms);
                    if (this.notifyVia.email) arr.push(NotificationMethodEnum.Email);
                    if (this.notifyVia.oncePerDay) arr.push(NotificationMethodEnum.OnceDay);

                    if (!arr.length) return null;

                    return arr.reduce((prevValue, currentValue, index) => {
                        return prevValue | currentValue;
                    });
                }
            });
        }

        public uncheckOncePerDay(): void {
            this.params.notifyVia.oncePerDay = false;
        }

    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoNotifyViaTabComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/tabs/notify-via-tab/notify-via-tab.component.html',
            controller: MeevoNotifyViaTabComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<'
            }
        });
}